import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";
import { Toaster } from "sonner";
import "../customer-theme.css";

export default function Layout({ children }) {
  return (
    <div className="customer-theme min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pb-24 sm:pb-0">{children}</main>
      <Footer />
      <FloatingActions />
      <Toaster position="top-center" richColors />
    </div>
  );
}
